import { JsonObject } from 'json2typescript';
import { CodeTextDiscriminatorModel } from 'humanresources-common-shared';

@JsonObject('KovanHrPerEmployeeTypeModel')
export class PerEmployeeTypeModel extends CodeTextDiscriminatorModel {}
